import { format } from "date-fns";
import { FieldValue, Timestamp } from "firebase/firestore";

export type AnalysisDateProps = {
  create: Timestamp | FieldValue | undefined;
  update?: Timestamp | FieldValue | undefined;
};

/**
 * 分析日時
 */
export default function AnalysisDate({ create, update }: AnalysisDateProps) {
  // フェールセーフ
  if (!(create instanceof Timestamp)) {
    return;
  }

  // 生成日時をフォーマット
  const createDate = (create as Timestamp).toDate();
  const createStr = format(createDate, "yyyy/MM/dd");

  // 更新日時をフォーマット
  let updateStr;
  if (update) {
    const updateDate = (update as Timestamp).toDate() ?? undefined;
    updateStr = updateDate ? format(updateDate, "yyyy/MM/dd") : "";
  }

  return (
    // <div className="mb-3 flex flex-col text-sm text-GRAY_1 md:flex-row">
    //   {update && <p className="mr-3">Update : {updateStr}</p>}
    //   <p>Create: {createStr}</p>
    // </div>
    <div className="mb-3 flex gap-4 text-xs text-GRAY_2 sm:flex-row md:text-sm">
      {update && (
        <div className="flex">
          <p className="">Update</p>
          <p>:&nbsp;{updateStr}</p>
        </div>
      )}
      <div className="flex">
        <p className="">Create</p>
        <p>:&nbsp;{createStr}</p>
      </div>
    </div>
  );
}
